define('views/pages/trade/offer/repeat/sidebar',[
    'jquery',
    'underscore',
    'mediator',
    'views/base/view',
    'views/base/collection',
    'lib/utils',

    'text!templates/pages/trade/offer/repeat/sidebar.ejs',
    'text!templates/pages/trade/offer/repeat/sidebar-row.ejs'

], function($, _, mediator, View, CollectionView, utils,

    templateTable,
    templateTableRow
) {
    'use strict';

    var TableRowView = View.extend({
        template: templateTableRow,
        tagName: 'tr',
        listen: {
            'change:selected model': 'render'
        },
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);
            this.delegate('click', this.clickRow);
        },
        clickRow: function(ev) {
            ev.stopPropagation();
            ev.preventDefault();

            var item = this.model.collection.findWhere({ selected: true });
            if (item && item !== this.model) {
                item.set('selected', false);
            }
            this.model.set('selected', true);
        },
        render: function() {
            View.prototype.render.apply(this, arguments);
            if (this.model.get('selected')) {
                this.$el.addClass('active');
            } else {
                this.$el.removeClass('active');
            }
        }
    });

    var TableView = CollectionView.extend({
        autoRender: true,
        animationDuration: 0,
        listSelector: 'tbody',
        loadingSelector: '.loading',
        fallbackSelector: '.empty',
        template: templateTable,
        region: 'repeat-sidebar',
        itemView: TableRowView
    });

    return TableView;
});

